(function () {
  'use strict';

  var instances = new Map();

  function NewArrivals(root) {
    this.root = root;
    this.track = root.querySelector('[data-arrivals-track]');
    this.pages = this.track ? Array.prototype.slice.call(this.track.querySelectorAll('.new-arrivals__page')) : [];
    this.prevButton = root.querySelector('[data-arrivals-prev]');
    this.nextButton = root.querySelector('[data-arrivals-next]');
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-arrivals-dot]'));
    this.pageCount = this.pages.length || 1;
    this.currentPage = 0;
    this.controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

    this.handlePrev = this.go.bind(this, -1);
    this.handleNext = this.go.bind(this, 1);

    this.initCarousel();
    this.initScrollEffect();
  }

  NewArrivals.prototype.signal = function () {
    return this.controller ? this.controller.signal : undefined;
  };

  NewArrivals.prototype.initCarousel = function () {
    var self = this;
    var signal = this.signal();

    if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev, { signal: signal });
    if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext, { signal: signal });

    this.dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        self.goToPage(index);
      }, { signal: signal });
    });
  };

  NewArrivals.prototype.go = function (direction) {
    this.goToPage((this.currentPage + direction + this.pageCount) % this.pageCount);
  };

  NewArrivals.prototype.goToPage = function (index) {
    if (!this.track || this.pageCount < 2) return;
    this.currentPage = index;
    this.track.style.transform = 'translateX(-' + (index * (100 / this.pageCount)) + '%)';
    this.dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  };

  // As New arrivals lifts over the sticky hero on scroll: the hero dims toward
  // dark grey (never disappears) via [data-hero-shadow], and this panel ramps
  // from solid cream into full liquid glass, then holds. See hero-slideshow.liquid.
  NewArrivals.prototype.initScrollEffect = function () {
    var self = this;
    var signal = this.signal();
    var heroShadow = document.querySelector('[data-hero-shadow]');
    var heroRoot = document.querySelector('[data-hero-slideshow]');
    if (!heroShadow || !heroRoot) return;

    var heroHeight = window.innerHeight;
    var glassZone = heroHeight + 600;
    var ticking = false;

    function update() {
      ticking = false;
      var scrollY = window.scrollY || window.pageYOffset;

      var heroProgress = Math.min(Math.max(scrollY / heroHeight, 0), 1);
      heroShadow.style.opacity = String(heroProgress * 0.9);

      var glassProgress = Math.min(Math.max(scrollY / glassZone, 0), 1);
      var bgAlpha = 1 - glassProgress * 0.94;
      var blur = glassProgress * 28;
      var borderAlpha = glassProgress * 0.4;

      self.root.style.background = 'rgba(245, 242, 236, ' + bgAlpha + ')';
      self.root.style.backdropFilter = 'blur(' + blur + 'px) saturate(180%)';
      self.root.style.webkitBackdropFilter = 'blur(' + blur + 'px) saturate(180%)';
      self.root.style.border = glassProgress > 0.05 ? '1px solid rgba(255, 255, 255, ' + borderAlpha + ')' : 'none';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function onResize() {
      heroHeight = window.innerHeight;
      glassZone = heroHeight + 600;
      update();
    }

    window.addEventListener('scroll', onScroll, { passive: true, signal: signal });
    window.addEventListener('resize', onResize, { signal: signal });
    update();
  };

  NewArrivals.prototype.destroy = function () {
    if (this.controller) this.controller.abort();
  };

  function initAll(container) {
    var scope = container || document;
    var roots = scope.querySelectorAll('[data-new-arrivals]');
    roots.forEach(function (root) {
      var sectionId = root.dataset.sectionId;
      if (instances.has(sectionId)) return;
      instances.set(sectionId, new NewArrivals(root));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('[data-new-arrivals]') : null;
    if (!root) return;
    var instance = instances.get(root.dataset.sectionId);
    if (instance) {
      instance.destroy();
      instances.delete(root.dataset.sectionId);
    }
  });
})();
